import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const CONNECT_CHANNEL = 'halr-connect';

/** Where a connect popup lands: tells the page that opened it, then closes itself. */
export default function ConnectDone() {
  const [params] = useSearchParams();
  const error = params.get('error') || params.get('crmError');

  useEffect(() => {
    const message = { type: 'halr:connect-finished', source: params.get('source'), error };
    try {
      const channel = new BroadcastChannel(CONNECT_CHANNEL);
      channel.postMessage(message);
      channel.close();
    } catch { /* older browsers fall back to the opener's status polling */ }
    try { window.opener?.postMessage(message, window.location.origin); } catch { /* opener may be gone */ }
    const timer = window.setTimeout(() => window.close(), 250);
    return () => window.clearTimeout(timer);
  }, [error, params]);

  return (
    <main className="mx-auto max-w-sm px-6 py-16 text-center text-neutral-90">
      <p className="text-[15px] font-medium">{error ? 'That did not connect.' : 'Connected.'}</p>
      <p className="mt-2 text-[13px] text-neutral-90/60">
        {error ? 'Close this window and try again from Halr.' : 'You can close this window.'}
      </p>
    </main>
  );
}
